import React from 'react';
import '../css/statistics.css';
import data from '../../../../data/layouts/statistics';
import AnimatedText from './AnimatedText';

const Statistics = () => {
  return (
    <section
      className="section-statistics  lazy-bg skeleton loaded"
      data-bg="url/images/statistics.webp)"
      style={{
        backgroundImage: 'url("./images/statistics.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        zIndex: '1',
        width: '100%',
        height: ' 100%',
      }}
    >
      <div className="olay-statistics">
        <div className="container ">
          <div className="box-title text-center mb-5 ">
            NHỮNG CON SỐ ĐÁNG TỰ HÀO
          </div>
          <div className="gird-statistics">
            {data.map((item, index) => (
              <div key={index} className="mt-md-3">
                <AnimatedText number={item.number} label={item.label} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;
